export default () => ({
    activeSlide: 0,
    totalSlides: 0,
    slideInterval: null,

    init() {
        this.startAutoSlide();
    },

    startAutoSlide() {
        if (this.slideInterval) {
            clearInterval(this.slideInterval);
        }

        this.slideInterval = setInterval(() => {
            this.nextSlide();
        }, window.config.CAROUSELS.OFFSET_IMAGE_CAROUSEL);
    },

    nextSlide() {
        this.activeSlide = (this.activeSlide + 1) % this.totalSlides;
        this.resetSlideInterval();
    },

    prevSlide() {
        this.activeSlide = (this.activeSlide - 1 + this.totalSlides) % this.totalSlides;
        this.resetSlideInterval();
    },

    resetSlideInterval() {
        this.startAutoSlide();
    },

    goToSlide(index) {
        this.activeSlide = index;
        this.resetSlideInterval();
    }
});